export enum ExecCommandEventsEnum {
  insertText = 'insertText',
  paste = 'paste',
  copy = 'copy',
}
